import axios from 'axios'

export function findBlackCar(data) {
    return axios({
        method: 'post',
        url:'/user/car/findBlackCar',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}


export function delBlackCar(data) {
    return axios({
        method: 'delete',
        url:'/user/car/delBlackCar?id='+data,
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}


export function getBlackType(data){
    return axios({
        method: 'get',
        url:'/user/common/getParamater?paratype='+data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}


export function addBlackCar(data){
    return axios({
        method: 'post',
        url:'/user/car/addBlackCar',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}